import { useObservability } from "@qamf/observability";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import guardInit from "./guard";
import attractionsRoutes, { attractionsOfferDetail } from "./routes/attractions";
import BaseRoutes from "./routes/base";
import PolicyTermPagesRoutes from "./routes/policyTerms";
import ReservationRoutes from "./routes/reservations";
export const notFoundFallbackViewName = "not-found-fallback";

interface IScrollPosition {
	top: number,
	left: number
}
const topPosition: IScrollPosition = {
	top: 0, left: 0
};

const router = createRouter({
	linkActiveClass: "active",
	history: createWebHistory(),
	routes: [
		...BaseRoutes,
		...attractionsRoutes,
		...ReservationRoutes,
		...PolicyTermPagesRoutes,
		...[
			{
				path: "/not-found",
				name: "not-found",
				component: () => import("@app-views/service/not-found/not-found.vue")
			},
			{
				path: "/:pathMatch(.*)*",
				redirect: "/not-found"
			}
		]
	] as RouteRecordRaw[],
	scrollBehavior: (to, from, savedPosition) => {
		if (to.name === attractionsOfferDetail && to.path === from.path)
			return false;

		return new Promise(resolve => {
			if (savedPosition) resolve(savedPosition);
			else resolve({ ...topPosition, behavior: "smooth" });
		});
	}
});

router.beforeEach((to, from, next) => {
	if (to.name) {
		const { trackView } = useObservability();
		trackView(to.name.toString(), "start", to.fullPath);
	}
	guardInit(to, from, next);
});

router.afterEach(to => {
	if (to.name) {
		const { trackView } = useObservability();
		trackView(to.name.toString(), "end", to.fullPath);
	}
});

export default router;
